import { getSchema, registeredSchemaNames } from "./blockschema"

export function inFraction(x: number): string {
  const sixteenths = Math.round(x * 16)
  const whole = Math.floor(sixteenths / 16)
  const rem = sixteenths % 16
  if (rem === 0) return `${whole}"`
  const g = gcd(rem, 16)
  const num = rem / g
  const den = 16 / g
  if (whole === 0) return `${num}/${den}"`
  return `${whole} ${num}/${den}"`
}

export function fmtYards(y: number): string {
  const n = Math.round(y * 8)
  const whole = Math.floor(n / 8)
  const rem = n % 8
  if (rem === 0) return `${whole} yd`
  const g = gcd(rem, 8)
  return whole > 0 ? `${whole} ${rem / g}/${8 / g} yd` : `${rem / g}/${8 / g} yd`
}

function gcd(a: number, b: number): number {
  while (b) { [a, b] = [b, a % b] }
  return a
}

const NON_BLOCK_LABELS: Record<string, string> = {
  sashing: "sashing",
  cornerstone: "cornerstone",
  setting: "setting triangle",
  setting_corner: "setting corner",
}

// Look up the human label for a role/piece. Searches every registered
// schema's patches first, then falls back to non-block labels (sashing,
// cornerstone, etc.), then returns the raw role string.
export function roleLabel(role: string): string {
  for (const name of registeredSchemaNames()) {
    const found = getSchema(name).patches.find((p) => p.name === role)
    if (found) return found.label
  }
  return NON_BLOCK_LABELS[role] ?? role
}
